import React, { forwardRef } from 'react';
import cm from 'classnames';
import { IntroKeys } from 'components/app/intro/intro-keys';
import styles from './_track-clip.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

export const ClipElement = forwardRef<HTMLDivElement, Props>(({ className, children, ...rest }: Props, ref) => {
  return (
    <div {...rest} ref={ref} className={cm(styles.ClipElement, className)} data-intro={IntroKeys.sbClip}>
      {children}
    </div>
  );
});
